



















































































































































import { defineComponent, toRefs, PropType, computed, ref, watch } from '@vue/composition-api';
import {
  AcoFormData,
  ACTION_TYPE,
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  IdentityInfo,
  IDENTITY_AVAILABLE_STATUS,
  IDENTITY_TYPE_MAP,
  isBOE,
  NATIVE_AD_IDENTITY_TYPES,
  UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP,
} from '@tt4b/ttam-enums';
import Identity from './index';
import { isNativeAdIdentityType } from '@tt4b/ttam-utils';
import TtamIdentityCustomCreateCompose from './identity-create-compose.vue';
// import TtamIdentityTiktokPostAuthorizeCompose from './identity-post-authorize-compose.vue';
import TtamIdentityTiktokPostNewAuthorizeCompose from './identity-post-authorize-new-compose.vue';
import QuestionTooltip from '@/components/common/question-tooltip/index.vue';
import { CreateIdentityFormData, IdentityFullInfo, IdentityItem, NativeIdentityType } from './types';
import {
  useCreativeActionTypeIs,
  useIdentityAdditional,
  useIdentityGet,
  useStdAdgroupIs,
  useStdCreativeAdgroupIs,
  useStore,
  StateEnum,
} from '@tt4b/ttam-hooks';
import { trackEvent } from './../../utils/index';
import { CUSTOM_IDENTITY_OPERATOR, SHOW_IDENTITY_AVAILABLE_LIST } from './const';
import { isEmpty } from 'lodash-es';
import { i18n } from './../../i18n';

const name = 'ttam-identity-compose';
export default defineComponent({
  name,
  components: {
    QuestionTooltip,
    TtamIdentityType: Identity.TtamIdentityType,
    // TtamIdentityTypeTips: Identity.TtamIdentityTypeTips,
    TtamIdentityCustomList: Identity.TtamIdentityCustomList,
    TtamIdentityTiktokList: Identity.TtamIdentityTiktokList,
    TtamIdentityTiktokAccount: Identity.TtamIdentityTiktokAccount,
    TtamIdentityTiktokTips: Identity.TtamIdentityTiktokTips,
    TtamIdentityTiktokTypeSelect: Identity.TtamIdentityTiktokTypeSelect,
    TtamIdentityErrorTips: Identity.TtamIdentityErrorTips,
    TtamIdentityCustomCreateCompose,
    // TtamIdentityTiktokPostAuthorizeCompose,
    TtamIdentityCustomCreateButton: Identity.TtamIdentityCustomCreateButton,
    TtamIdentityTiktokPostNewAuthorizeCompose,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: ACTION_TYPE.CREATE,
    },
    bindTtbaAccountData: {
      type: Object as PropType<Partial<IdentityInfo>>,
      default: () => ({}),
    },
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
    // 错误字段map，初始化后的报错信息
    errorsMap: {
      type: Object as PropType<Record<string, string>>,
      default: () => ({}),
    },
  },
  // eslint-disable-next-line max-lines-per-function
  setup(props, { emit }) {
    const { creativeData, adgroupData, campaignData, createMode, isDisabledCreative } = toRefs(props);
    const { isAco } = useStdCreativeAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { identityValidator } = Identity.useIdentityRules({
      createMode,
      adgroupData,
    });
    const { isStandardAdsWithShop } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { isEdit } = useCreativeActionTypeIs({
      createMode,
      adgroupFormData: adgroupData,
    });
    // tiktok identity
    const {
      dataSource: TikTokAccount,
      originalData: TikTokAccountOriginalData,
      run: getTikTokAccount,
      isLoading: isTikTokAccountLoading,
      error: isTikTokAccountError,
    } = Identity.useTikTokAccountDataSource();

    const { linkUrl, tips, linkText } = Identity.useIdentityTypeTipsPropsTipsAndLink();

    const {
      disabled: identityTypeDisabled,
      disabledTips: identityTypeDisabledTips,
      visible: identityTypeVisible,
    } = Identity.useIdentityTypeProps({
      campaignData,
      adgroupData,
      creativeData,
      createMode,
      isDisabledCreative,
    });

    const { isDisabledSwitchNativeType } = Identity.useNativeTypeSwitchDisabled({
      campaignData,
      adgroupData,
      creativeData,
      createMode,
      isDisabledCreative,
    });

    const curIdentityType = computed(() => creativeData.value.identityType);
    const curIdentity = computed(() => creativeData.value?.identityData);
    const curIdentityId = computed(() => creativeData.value?.identityData?.identityId);
    const curTikTokAccountInfo = computed(() => {
      if (curIdentityType.value === IDENTITY_TYPE_MAP.TT_USER) {
        const val = {
          ...curIdentity.value,
          ...props.bindTtbaAccountData,
        } as Partial<IdentityInfo>;
        return {
          name: val?.displayName,
          id: val?.identityId,
          avatar: val?.avatarIcon?.url as string,
          unavailable: SHOW_IDENTITY_AVAILABLE_LIST.includes(val?.availableStatus),
          availableStatus: val?.availableStatus,
        };
      }
      return TikTokAccount;
    });

    const curCustomIdentityId = ref('');
    const curAuthIdentityId = ref('');
    const curNativeType = ref(IDENTITY_TYPE_MAP.TT_USER);
    const resetRefData = () => {
      const isCustom = curIdentityType.value === IDENTITY_TYPE_MAP.FAKE_USER;
      const isAuth = [
        IDENTITY_TYPE_MAP.AUTH_CODE_USER,
        IDENTITY_TYPE_MAP.BC_SELF_TT,
        IDENTITY_TYPE_MAP.BC_AUTH_TT,
        IDENTITY_TYPE_MAP.TTS_TT,
      ].includes(curIdentityType.value);
      curCustomIdentityId.value = isCustom ? curIdentityId.value : '';
      curAuthIdentityId.value = isAuth ? curIdentityId.value : '';
      curNativeType.value = IDENTITY_TYPE_MAP.TT_USER;
    };

    // 初始化组件内部的值，用于记录用户的选择
    resetRefData();

    const onLinkClick = () => {
      emit('tips-click');
    };

    const emitTiktokAccount = (data: IdentityInfo) => {
      emit('identity-change', {
        identityId: '',
        ...data,
        identityType: IDENTITY_TYPE_MAP.TT_USER,
      });
      emit('tiktok-identity-change', data || null);
    };
    const emitCustomIdentityAccount = (data: IdentityInfo) => {
      curCustomIdentityId.value = data?.identityId;
      emit('identity-change', data || null);
      emit('custom-identity-change', data || null);
    };

    const emitAuthorizePostTikTokAccount = (data: IdentityInfo) => {
      curAuthIdentityId.value = data?.identityId;
      emit('identity-change', data || null);
      emit('authorize-post-tiktok-identity-change', data || null);
    };

    const {
      dataSource: customIdentity,
      originalData: originalCustomIdentity,
      isEmpty: isCustomIdentityEmpty,
      isLoading: isCustomIdentityLoading,
      run: getCustomIdentityList,
      error: isCustomIdentityError,
    } = Identity.useCustomListDataSource({ campaignData, adgroupData });

    const onCustomIdentityChange = (val: IdentityItem) => {
      const find = originalCustomIdentity.value.find(i => i.identityId === val.id);
      emitCustomIdentityAccount(find);
    };

    // custom identity create data
    const customOperateModalData = ref();
    // 选择 edit 的那项数据
    const customOperateModalOriData = ref();
    const customOperateVisible = ref(false);
    const dialogType = ref(CUSTOM_IDENTITY_OPERATOR.ADD);

    const handleEditIdentity = (item: IdentityFullInfo) => {
      dialogType.value = CUSTOM_IDENTITY_OPERATOR.EDIT;
      customOperateModalData.value = {
        avatarIcon: item?.avatarIcon || {},
        displayName: item?.displayName || '',
      };
      customOperateModalOriData.value = item;
      customOperateVisible.value = true;
    };

    const onCustomIdentityAddClick = () => {
      dialogType.value = CUSTOM_IDENTITY_OPERATOR.ADD;
      customOperateVisible.value = true;
    };

    const onCustomOperateModalClose = () => {
      customOperateVisible.value = false;
      customOperateModalData.value = {};
    };

    const {
      run: submitCustomIdentity,
      isLoading: customIdentityCreating,
      error: customIdentityCreateError,
    } = Identity.useCustomCreateSubmit({
      modalForm: customOperateModalData,
    });
    const {
      run: updateCustomIdentity,
      data: customIdentityUpdateResult,
      isLoading: customIdentityUpdating,
      error: customIdentityUpdateError,
    } = Identity.useCustomUpdateSubmit({
      modalForm: customOperateModalData,
      originData: customOperateModalOriData,
    });

    const customIdentityConfirmLoading = computed(() =>
      dialogType.value === CUSTOM_IDENTITY_OPERATOR.ADD ? customIdentityCreating.value : customIdentityUpdating.value,
    );

    const onCustomIdentityAdd = async (val: CreateIdentityFormData) => {
      customOperateModalData.value = val;
      await submitCustomIdentity();
      if (customIdentityCreateError.value) {
        trackEvent('upgrade_identity_create_new_custom_identity_failed');
      } else {
        trackEvent('upgrade_identity_create_new_custom_identity_success');
      }
      onCustomOperateModalClose();
      const data = originalCustomIdentity.value?.[0];
      emitCustomIdentityAccount(data);
    };
    const onCustomIdentityEdit = async (val: CreateIdentityFormData) => {
      customOperateModalData.value = val;
      await updateCustomIdentity();
      const isChange =
        customIdentityUpdateResult.value?.identityInfo?.identityId !== customOperateModalOriData.value?.identityId;
      if (customIdentityUpdateError.value) {
        trackEvent('edit_custom_identity_submit', { result: true, status: isChange.toString() });
      } else {
        trackEvent('edit_custom_identity_submit', { result: false });
      }
      onCustomOperateModalClose();
      const data = originalCustomIdentity.value?.[0];
      emitCustomIdentityAccount(data);
    };

    const {
      dataSource: TikTokIdentityList,
      originalData: originalTikTokIdentityList,
      isEmpty: isTikTokIdentityEmpty,
      isLoading: isTikTokIdentityLoading,
      run: getTikTokIdentityList,
      error: isTikTokIdentityListError,
    } = Identity.useTikTokListDataSource({
      campaignData,
      adgroupData,
    });

    const onAuthorizePostIdentityChange = (val: IdentityItem) => {
      const identityData = originalTikTokIdentityList.value?.find(i => i.identityId === val.id);
      emitAuthorizePostTikTokAccount(identityData);
    };

    const getDefaultIdentityItemOnChangeSwitch = (identityType: number) => {
      const { TT_USER, FAKE_USER } = IDENTITY_TYPE_MAP;
      let targetItem;
      if (identityType === FAKE_USER) {
        targetItem = originalCustomIdentity.value.find(item => item.identityId === curCustomIdentityId.value) || {};
      } else if (identityType === TT_USER) {
        targetItem = TikTokAccountOriginalData.value || {};
      } else {
        targetItem = originalTikTokIdentityList.value.find(item => item.identityId === curAuthIdentityId.value) || {};
      }
      return { identityType, identityId: '', ...targetItem };
    };

    const isUseTTAccount = computed({
      get: () => isNativeAdIdentityType(creativeData.value.identityType),
      set: (val: boolean) => {
        const { TT_USER, FAKE_USER } = IDENTITY_TYPE_MAP;
        if (val) {
          const trackType = curNativeType.value === TT_USER ? 'upgrade_identity_ttba_tab' : 'upgrade_identity_tta_tab';
          trackEvent(trackType, {
            is_aco: Boolean(isAco.value),
          });
        }

        const curType = val ? curNativeType.value : FAKE_USER;
        emit('is-native-change', curType, val);

        let targetItem = getDefaultIdentityItemOnChangeSwitch(curType);
        emit('identity-change', targetItem);
      },
    });

    const { map: typeSelectMap } = Identity.useTikTokTypeSelectPropsMap({
      campaignData,
    });
    const curTikTokType = computed({
      get: () =>
        creativeData.value.identityType === IDENTITY_TYPE_MAP.TT_USER
          ? NativeIdentityType.TIKTOK
          : NativeIdentityType.POST,
      set: (val: NativeIdentityType) => {
        let type = IDENTITY_TYPE_MAP.TT_USER;
        if (val === NativeIdentityType.TIKTOK) {
          type = IDENTITY_TYPE_MAP.TT_USER;
        } else if (isAco.value) {
          type = IDENTITY_TYPE_MAP.AUTH_CODE_USER;
        } else {
          type = IDENTITY_TYPE_MAP.BC_AUTH_TT;
        }
        const trackType =
          type === IDENTITY_TYPE_MAP.TT_USER ? 'creative_identity_select_ttba_tab' : 'creative_identity_select_tta_tab';
        trackEvent(trackType, {
          is_aco: Boolean(isAco.value),
        });
        curNativeType.value = type;
        emit('identity-type-change', type);
      },
    });

    const isLinkError = ref(false);
    const { state } = useStore();
    const aadvid = computed(() => state[StateEnum.baseInfo].value?.aadvid);
    const { onLink, onUnLink, updateTTBA } = Identity.useTikTokAccountEvents<{
      scene: string;
    }>({
      oauthConfig: ref({
        extraParam: {
          scene: 'bind',
          aadvid,
        },
      }),
      onLinkSuccess: async data => {
        isLinkError.value = false;
        await getTikTokAccount();
        emitTiktokAccount(TikTokAccountOriginalData.value);
        const accountStatus = TikTokAccountOriginalData.value?.availableStatus;
        // 去升级企业号
        if (accountStatus === IDENTITY_AVAILABLE_STATUS.NOT_BUSINESS_ACCOUNT) {
          await updateTTBA('ttba-container');
          await getTikTokAccount();
          emitTiktokAccount(TikTokAccountOriginalData.value);
        }
        emit('link-success', data);
        trackEvent('upgrade_identity_ttba_tab_authorize_success');
      },
      onLinkFail(data) {
        isLinkError.value = true;
        emit('link-fail', data);
        trackEvent('upgrade_identity_ttba_tab_authorize_failed');
      },
      onUnLinkSuccess: async () => {
        await getTikTokAccount();
        emitTiktokAccount(TikTokAccountOriginalData.value);
        trackEvent('upgrade_identity_unlink_success');
      },
    });

    const hasError = computed(
      () =>
        isLinkError.value ||
        isCustomIdentityError.value ||
        isTikTokAccountError.value ||
        isTikTokIdentityListError.value,
    );

    const onRefresh = async (needLoad: boolean) => {
      emit('identity-refresh');
      if (curTikTokType.value === NativeIdentityType.TIKTOK) {
        needLoad && (await getTikTokAccount());
        emitTiktokAccount(TikTokAccountOriginalData.value);
      } else {
        needLoad && (await getTikTokIdentityList());
        let targetItem = originalTikTokIdentityList.value.find(item => item.identityId === curAuthIdentityId.value);
        if (targetItem) {
          emitAuthorizePostTikTokAccount(targetItem);
        } else {
          const data = originalTikTokIdentityList.value?.[0];
          if (!isEmpty(data)) {
            emitAuthorizePostTikTokAccount(data);
          }
        }
      }
    };

    const isIdentityIdNotMatch = computed(
      () =>
        ![
          TikTokAccountOriginalData.value.identityId || '',
          curCustomIdentityId.value,
          curAuthIdentityId.value,
        ].includes(curIdentityId.value),
    );

    watch([isIdentityIdNotMatch], () => {
      if (isIdentityIdNotMatch.value) {
        // 组件内部维护了用户选择的值，但是存在一些场景会在外部改动 identityId（比如删除唯一一项 ad list 中的数据），此时需要重置用户选择的值
        resetRefData();
      }
    });

    const emitIdentityByIdentityType = (identityType: number) => {
      if (isNativeAdIdentityType(identityType)) {
        // 不请求接口
        onRefresh(false);
      } else {
        let targetItem = originalCustomIdentity.value.find(item => item.identityId === curCustomIdentityId.value);
        if (targetItem) {
          emitCustomIdentityAccount(targetItem);
        } else {
          const data = originalCustomIdentity.value?.[0];
          emitCustomIdentityAccount(data);
        }
      }
    };

    watch([curIdentityType], () => {
      emitIdentityByIdentityType(curIdentityType.value);
    });

    const { title: tiktokTipsTitle, ctaText: tiktokTipsCTA } = Identity.useTikTokTipsProps({
      createMode,
      identityInfo: curIdentity,
      adgroupData,
    });
    const { visible: tiktokTipsVisible } = Identity.useTikTokTipsVisible({
      identityInfo: curIdentity,
    });
    const bcDomain = isBOE ? '//boei18n-business.byteoversea.net' : '//business.tiktok.com';
    const onTikTokTipsClick = async () => {
      const { identityType, availableStatus, identityBcId } = curIdentity?.value;
      if (
        identityType === IDENTITY_TYPE_MAP.BC_AUTH_TT &&
        availableStatus === IDENTITY_AVAILABLE_STATUS.BC_NO_VIDEO_RIGHT
      ) {
        const url = `${bcDomain}/manage/tiktok?org_id=${identityBcId}`;
        window.open(url, '_blank');
      } else if (identityType === IDENTITY_TYPE_MAP.TT_USER) {
        if (
          [IDENTITY_AVAILABLE_STATUS.IS_PRIVATE_ACCOUNT, IDENTITY_AVAILABLE_STATUS.NOT_BUSINESS_ACCOUNT].includes(
            availableStatus,
          )
        ) {
          // 企业号升级
          trackEvent('upgrade_identity_upgrade_ba');
          await updateTTBA('ttba-container');
          await getTikTokAccount();
          emitTiktokAccount(TikTokAccountOriginalData.value);
        } else {
          trackEvent('upgrade_identity_get_permission');
          // TT 授权
          onLink();
        }
      } else if (identityType === IDENTITY_TYPE_MAP.TTS_TT) {
        const url = 'https://ads.tiktok.com/help/article/how-to-get-showcase-permission';
        window.open(url, '_blank');
      }
    };

    const onReload = () => {
      isLinkError.value = false;
      getTikTokAccount();
      getTikTokIdentityList();
      getCustomIdentityList();
      emitIdentityByIdentityType(curIdentityType.value);
    };

    const onOperateModalChange = (data: CreateIdentityFormData) => {
      emit('identity-change', data);
    };
    const authVideo = function ({ id }) {
      onAuthorizePostIdentityChange({ id } as IdentityItem);
    };
    const TikTokIdentityListData = computed(() => {
      let list = TikTokIdentityList.value;
      list.forEach(item => {
        // 原生identity账号通用的禁用逻辑，优先级最低
        if (NATIVE_AD_IDENTITY_TYPES.includes(item.identityType) && !item.displayName && !item.disabled) {
          item.disabled = true;
          item.enablePopover = true;
          item.popoverTitle = UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP()?.[
            IDENTITY_AVAILABLE_STATUS.NATIVE_AD_IDENTITY_NO_DISPLAY_NAME
          ]?.tooltipText as string;
          item.popoverCTA = UNAVAILABLE_IDENTITY_ACCOUNT_STATUS_MAP()?.[
            IDENTITY_AVAILABLE_STATUS.NATIVE_AD_IDENTITY_NO_DISPLAY_NAME
          ]?.authorizationDesc as string;
        }
      });
      return list;
    });
    return {
      name,
      isEdit,
      curIdentity,
      tips,
      linkUrl,
      identityTypeDisabled,
      identityTypeDisabledTips,
      isTikTokAccountError,
      isTikTokIdentityListError,
      isCustomIdentityError,
      isLinkError,
      isAco,
      hasError,
      linkText,
      curIdentityId,
      TikTokAccount,
      tiktokTipsCTA,
      curTikTokType,
      typeSelectMap,
      isUseTTAccount,
      customIdentity,
      tiktokTipsTitle,
      tiktokTipsVisible,
      customOperateModalData,
      customOperateVisible,
      isTikTokIdentityEmpty,
      isCustomIdentityEmpty,
      isTikTokAccountLoading,
      TikTokIdentityList: TikTokIdentityListData,
      isTikTokIdentityLoading,
      isCustomIdentityLoading,
      identityTypeVisible,
      dialogType,
      isStandardAdsWithShop,
      curTikTokAccountInfo,
      onLink,
      onUnLink,
      onReload,
      onRefresh,
      onLinkClick,
      onTikTokTipsClick,
      onCustomIdentityChange,
      onCustomIdentityAdd,
      onCustomIdentityEdit,
      onCustomIdentityAddClick,
      onAuthorizePostIdentityChange,
      handleEditIdentity,
      onCustomOperateModalClose,
      customIdentityConfirmLoading,
      curCustomIdentityId,
      curAuthIdentityId,
      getTikTokIdentityList,
      identityValidator,
      onOperateModalChange,
      isDisabledSwitchNativeType,
      getCustomIdentityList,
      authVideo,
    };
  },
});
